export default [
  {
    path: '',
    component: DefaultLayout,
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import(/* webpackChunkName: "HomeIndex" */ './HomeIndex'),
        meta: {
          title: '主页',
        },
      },
    ],
  },
]
